module.exports = __webpack_public_path__ + "img/user-circle-solid.c3580913.svg";